import { Pipe, PipeTransform } from '@angular/core';
import { RouteState } from '../../entity/enums';

@Pipe({
    name: 'showVehicleIcon',
    pure: true,
    standalone: false
})
export class ShowVehicleIconPipe implements PipeTransform {
  transform(routeData: any, selectedKPIRoutes: any): any {
    // Logic to determine if vehicle icon should be shown based on the selected route state 
    let showIcon: boolean = false;
    showIcon =
      routeData.route_state.toLowerCase() === RouteState.Onroute &&
      selectedKPIRoutes?.map((m: any) => m.route_id)?.includes(routeData.route_id);
    return showIcon;
  }
}
